import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { CountriesList, Country } from '@app/utils/interfaces/countries-list';

@Injectable({
  providedIn: 'root',
})
export class GetCountriesService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly httpClient = inject(HttpClient);

  public getCountries(): Observable<CountriesList> {
    return this.httpClient.get<CountriesList>(`${this.baseUrl}${ApiEndpoints.GET_COUNTRIES}`).pipe(
      map((list: CountriesList) => {
        list.data.sort((countryA: Country, countryB: Country) =>
          countryA.name.localeCompare(countryB.name),
        );
        return list;
      }),
      shareReplay(1),
    );
  }
}
